import { defaultTheme } from "../../config/defaultTheme";

export const createConfigSlice = (set, get) => ({
  // Configuration state
  commands: {},
  translations: {},
  initialMessage: [],
  theme: defaultTheme,
  promptLabel: ">",
  outputDelay: 800, // Delay in milliseconds for system output (default 800ms)
  typingSpeed: 50, // Speed in milliseconds between characters for typing effect (default 50ms)
  promptDelay: 300, // Delay in milliseconds before prompt appears after output (default 300ms)
  sentencePause: 0, // Extra pause in ms after sentence-ending punctuation (. ! ? ;) during typing (0 = disabled)

  // Configuration setters
  setCommands: (commands) => set({ commands }),
  setTranslations: (translations) => set({ translations }),
  setInitialMessage: (initialMessage) => set({ initialMessage }),
  setPromptLabel: (promptLabel) => set({ promptLabel }),
  setOutputDelay: (delay) => set({ outputDelay: delay }),
  setTypingSpeed: (speed) => set({ typingSpeed: speed }),
  setPromptDelay: (delay) => set({ promptDelay: delay }),
  setSentencePause: (pause) => set({ sentencePause: pause }),
  setTheme: (newTheme) => {
    if (newTheme && typeof newTheme === "object") {
      set({ theme: newTheme });
    } else {
      console.warn("Invalid theme passed to setTheme:", newTheme);
      set({ theme: defaultTheme });
    }
  },
});
